export const stopStream = stream => {
  if (!stream) {
    return;
  }
  stream.getTracks().forEach((mediaTrack) => {
    mediaTrack.stop();
  });
};
